import { Option } from "api/types/_public";
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import { useRole } from 'components/Hooks/UserHooks';
import { useFormik } from "formik";
import { SYSTEM_CONFIG_KEY } from 'helpers/constans';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, Col, Container, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { getAllCategory, getConfiguration, putConfiguration } from 'store/thunks';
import * as Yup from "yup";


const Configuration = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const selectLayoutState = (state: any) => state.System;

  const SystemProperties = createSelector(
    selectLayoutState,
    (state) => ({
      configs: state.configs,
      isConfigSuccess: state.isConfigSuccess,
      isConfigLoading: state.isConfigLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { configs } = useSelector(SystemProperties);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [categories, setCategories] = useState<Option[]>([]);


  const handleSubmit = async (values: any) => {
    if (isLoading) {
      return;
    }
    setIsOpen((_prev) => true);
  };

  const handleSubmitConfiguration = async (values: any) => {
    try {
      if (isLoading) {
        return;
      }

      setIsLoading((_prev) => true);

      const _data_configs = {
        configs: [
          {
            key: SYSTEM_CONFIG_KEY.USER_POPULAR_CATEGORY_IDS,
            value: JSON.stringify(values?.category_ids?.map((_c: string) => _c) || []),
            is_active: 1,
          },
        ]
      };

      const [res1]: any = await Promise.all([putConfiguration(_data_configs)]);
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      if (res1?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
      } else {
        toast(`${res1?.message || res1}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpen((_prev) => false);
      setIsLoading((_prev) => false);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const validationSchema = Yup.object({
    category_ids: Yup.array().of(Yup.string()).nullable(),
  });

  const formik = useFormik({
    initialValues: {
      category_ids: [],
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const handleCallAllOption = async () => {
    try {
      const [res1, res2]: any = await Promise.all([getAllCategory({}), getConfiguration({})]);
      const _configs = res2?.data?.list || [];
      const _categories = (res1?.data || [])?.map((item: any) => ({ value: `${item?.id}`, label: item?.name }));
      setCategories((_prev: any) => _categories);

      const _config_categories = _configs?.find((item: any) => item?.key === SYSTEM_CONFIG_KEY.USER_POPULAR_CATEGORY_IDS) || {};

      const _category_ids = (_config_categories?.value || [])?.map((_c: any) => `${_c}`);
      formik?.setFieldValue('category_ids', _category_ids);

    } catch (error: any) {
      return error;
    }
  };

  const handelSelectCategory = (_value: string = '') => {
    const _category_ids: string[] = formik?.values?.category_ids || [];
    if (_category_ids?.includes(_value)) {
      const _v = _category_ids?.filter((_c) => _c !== _value);
      formik.setFieldValue("category_ids", _v);
    } else {
      const _v = [..._category_ids, _value];
      formik.setFieldValue("category_ids", _v);
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Configuration')} - ${t('Popular Keyword (User)')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Popular Keyword (User)')} pageTitle={t('Configuration')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_AI_CUSTOM_NEWS, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)', minHeight: '75dvh' }}>
                  <CardBody className="pt-3">
                    <form onSubmit={formik.handleSubmit} style={{ maxWidth: '900px', margin: 'auto' }}>
                      <Row>
                        <Col md={12} className="px-4 mt-4 mt-md-0">
                          <Row>
                            <div className="mb-3 position-relative" style={{ border: '1px dashed var(--vz-primary)', borderRadius: '4px', padding: '10px' }}>
                              <span className="text-primary position-absolute fs-13 px-1" style={{ backgroundColor: "var(--vz-secondary-bg)", top: '0px', transform: 'translateY(-50%)' }}>{t('Category')}</span>
                              <Col lg={12} className="mt-2 mb-1 ms-1">
                                <div className="form-check mb-0 mt-0" >
                                  <Input className="form-check-input"
                                    type="checkbox"
                                    // role="switch"
                                    id="is_all_category"
                                    name="is_all_category"
                                    checked={!!((formik?.values?.category_ids || [])?.length && ((formik?.values?.category_ids || [])?.length === categories?.length))}
                                    onChange={(event: any) => {
                                      formik.setFieldValue('category_ids', !!(event?.target.checked) ? categories?.map((_c) => _c?.value) : []);
                                    }}
                                  />
                                  <Label className="form-check-label text-muted" for="is_all_category">{t('All Category')}</Label>
                                </div>
                              </Col>
                              <Col sm={12} md={12} xl={12} xxl={12} className="pt-2 pb-3 px-1">
                                <div style={{ height: '60dvh' }} className="overflow-y-auto color-scrollbar-os">
                                  <div className="d-flex gap-2 flex-wrap">
                                    {categories?.map((item) => (
                                      <button type="button" className={`btn px-3 px-md-4 py-btn-section ${((formik?.values?.category_ids || []) as string[])?.includes(`${item?.value}`) ? `bg-primary-subtle text-primary` : `border-gray text-secondary`}`} key={item?.value}
                                        onClick={(e) => { e.preventDefault(); handelSelectCategory(`${item?.value}`) }}
                                      >
                                        {item?.label}
                                      </button>
                                    ))}
                                  </div>
                                </div>
                              </Col>
                            </div>
                          </Row>
                        </Col>

                        <Col sm={12} md={12} xl={12} className='mt-1 pt-1 text-end'>
                          <button
                            style={{ width: '150px' }}
                            type="submit"
                            disabled={(isLoading)}
                            className="btn btn-primary fs-14 rounded-pill">
                            {<>{t('Button Update')}</>}
                          </button>
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <Modal
          isOpen={!!isOpen}
          centered={true}
          // size="lg"
          toggle={() => setIsOpen(false)}
          keyboard={true}
        >
          <ModalHeader>
            {t('Configuration')}
          </ModalHeader>
          <ModalBody className="">
            <div className="row g-4">
              <Col sm={12}>
                <div className="row g-3">
                  <div className="mt-3 text-center">
                    <h6 className="mb-2 fs-19 text-center mt-1">
                      {t("Are you sure you want to update this?")}
                    </h6>
                    <p className="fs-15 mb-4 d-flex justify-content-center align-items-start align-items-sm-center text-center ">
                      {t('After confirming the update action, the data will be updated. Do you want to proceed with the update action.')}
                    </p>
                    <div className="d-flex gap-3 mt-2 justify-content-center">
                      <button
                        className="btn btn-primary rounded-pill fs-14"
                        type="button"
                        color="light"
                        onClick={() => handleSubmitConfiguration(formik?.values)}
                        style={{ width: '120px' }}
                      >
                        {(isLoading) ? <Spinner size="sm me-2" ></Spinner> : <>{t('Button Update')}</>}
                      </button>
                      <button
                        className="btn btn-secondary rounded-pill fs-14 ms-2"
                        type="button"
                        color="light"
                        onClick={() => setIsOpen(false)}
                        style={{ width: '120px' }}
                      >
                        {t("Button Close")}
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </ModalBody>
        </Modal >

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default Configuration;

